import { render, staticRenderFns } from "./GoodsInIndex.vue?vue&type=template&id=4e938f74&scoped=true"
import script from "./GoodsInIndex.vue?vue&type=script&lang=js"
export * from "./GoodsInIndex.vue?vue&type=script&lang=js"
import style0 from "./GoodsInIndex.vue?vue&type=style&index=0&id=4e938f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e938f74",
  null
  
)

export default component.exports